import {useState} from 'react'
import {Icon, Layout, PopoutCard} from '../..'
import {makeCnVariants} from '../../../helpers'
import {TruncateTooltip} from './truncate_tooltip'

const INFO_ICON_WIDTH = 18

export const InfoPopout = ({
	text,
	element,
	truncate,
	iconName = 'question-mark',
	PopoutComponent = PopoutCard,
	showTruncateTooltip,
	t,
	popoutTitle,
	popoutBody,
	...rest
}) => {
	const [animationActive, setAnimationActive] = useState()

	const popoutClassNames = makeCnVariants('info-popout', animationActive && 'animated', iconName)

	const stopClick = e => {
		e.stopPropagation()
		e.preventDefault()
	}

	return (
		<Layout className="info-popout-container" vertical="center" {...(truncate && {width: 'full'})}>
			{showTruncateTooltip ? <TruncateTooltip element={element} text={text} width={`calc(100% - ${INFO_ICON_WIDTH}px`} /> : element}
			<PopoutComponent title={popoutTitle} body={popoutBody} {...rest} className={popoutClassNames} layoutProps={{gap: 0}}>
				<Icon name={iconName} fill="#FFF" size={14} onClick={stopClick} />
			</PopoutComponent>
		</Layout>
	)
}
